import get from 'lodash/get';
import {
	CREATE_NEW_APPEAL, CREATE_NEW_APPEAL_ERROR,
	GET_APPEAL_TYPES_LIST_SUCCESS, GET_APPEAL_TYPES_LIST_ERROR, GET_DINAMIC_FORM_PARAMS,
	GET_DINAMIC_FORM_PARAMS_SUCCESS, GET_DINAMIC_FORM_PARAMS_ERROR,
	GET_APPEAL_STATUS_LIST, GET_APPEAL_STATUS_LIST_SUCCESS, GET_APPEAL_STATUS_LIST_ERROR,
	SAVE_APPEAL, SAVE_APPEAL_SUCCESS, SAVE_APPEAL_ERROR, APPEAL_DESTINATIONS_REQUEST,
	APPEAL_DESTINATIONS_REQUEST_SUCCESS, APPEAL_DESTINATIONS_REQUEST_FAILURE, UNLOCK_APPEAL_FORM,
	UNLOCK_APPEAL_FORM_SUCCESS, UNLOCK_APPEAL_FORM_ERROR, LOCK_APPEAL_FORM, GET_APPEAL_PRIORITY_LIST,
	GET_APPEAL_PRIORITY_LIST_SUCCESS, GET_APPEAL_PRIORITY_LIST_ERROR, GET_APPEAL_FEEDBACK, GET_APPEAL_FEEDBACK_SUCCESS,
	GET_APPEAL_FEEDBACK_ERROR, CLEAR_APPEAL_FEEDBACK, APPEAL_REQUEST, APPEAL_REQUEST_SUCCESS,
	APPEAL_REQUEST_FAILURE, APPEAL_WORKSPACE_HYDRATE, APPEAL_WORKSPACE_BOOTSTRAP_CONSUME,
	APPEAL_WORKSPACE_SCHEMA_HYDRATE,
	CLEAR_APPEAL_STATE, GET_APPEAL_ACTIONS, SET_APPEAL_ACTIONS,
	SET_FIRST_LEVEL_ACTION, SET_RESOLUTION_ACTION, REMOVE_REFRESH_APPEAL_MODAL,
	ADD_TABS, SET_MODAL_STATUS_LIST, SET_STATUS_MODAL_VISIBILITY, SET_CURRENT_TAB_NAME_BLOCKED,
	APPEAL_FETCHING, REMOVE_CUSTOMER_FROM_APPEAL, ADD_CUSTOMER_TO_APPEAL, CLEAR_ALL_APPEALS,
	SAVE_AND_CREATE_NEW, ADD_CREATED_APPEAL, UPDATE_CREATED_APPEAL_NAME, SET_APPEAL_HAS_UNSAVED_CHANGES,
} from 'constants/actions';
import { showNotification } from './ui';
import { NotificationTypes } from 'constants/index';
import * as api from 'api';
import store from 'store';
import { reportMessage } from 'api/errorHandle';

const APPEAL_ACCESS_DENIED_CODE = -20403;
const APPEAL_ACCESS_DENIED_PATTERN = /(ORA-20403|code=-?20403|відсутні права на перегляд)/i;
const APPEAL_NOT_FOUND_CODE = 100;
const APPEAL_NOT_FOUND_PATTERN = /(ORA-01403|code=100|no data found)/i;
const SILENT_SKIPPED_SAVE_REASONS = new Set([
	'duplicate_payload',
	'incomplete_payload',
	'mutex_busy',
]);
const APPEAL_SAVE_RESPONSE_DEBUG_FIELD_KEYS = ['bp407', 'bp502', 'bp503', 'bp505', 'bp506', 'bp507', 'bp524', 'bp525', 'bp526'];

const extractAppealSaveResponseDebugFields = (dynamicFields = {}) => (
	APPEAL_SAVE_RESPONSE_DEBUG_FIELD_KEYS.reduce((accumulator, key) => {
		accumulator[key] = dynamicFields?.[key] ?? null;
		return accumulator;
	}, {})
);

const extractAppealErrorCode = (payload) => {
	const code = get(payload, 'response.data.errorCode',
		get(payload, 'response.errorCode',
			get(payload, 'data.errorCode', payload?.errorCode)));
	const normalizedCode = Number(code);
	return Number.isFinite(normalizedCode) ? normalizedCode : null;
};

const extractAppealErrorMessage = (payload) => {
	return get(payload, 'response.data.errorMessageText')
		|| get(payload, 'response.data.errorMessage')
		|| get(payload, 'response.errorMessageText')
		|| get(payload, 'response.errorMessage')
		|| payload?.errorMessageText
		|| payload?.errorMessage
		|| get(payload, 'data.errorMessageText')
		|| get(payload, 'data.errorMessage')
		|| payload?.message;
};

const isAppealAccessDenied = (payload) => {
	if (!payload) {
		return false;
	}

	const errorCode = extractAppealErrorCode(payload);

	if (errorCode === APPEAL_ACCESS_DENIED_CODE) {
		return true;
	}

	const errorMessage = String(extractAppealErrorMessage(payload) || '');
	return APPEAL_ACCESS_DENIED_PATTERN.test(errorMessage);
};

const isAppealNotFound = (payload) => {
	if (!payload) {
		return false;
	}

	const errorCode = extractAppealErrorCode(payload);

	if (errorCode === APPEAL_NOT_FOUND_CODE) {
		return true;
	}

	const errorMessage = String(extractAppealErrorMessage(payload) || '');
	return APPEAL_NOT_FOUND_PATTERN.test(errorMessage);
};

export function removeCustomerFromAppeal(id) {
	return (dispatch) => {
		dispatch({
			type: REMOVE_CUSTOMER_FROM_APPEAL,
			id,
		});
	};
}

export function addCustomerToAppeal(id, customerId, contactPersonId) {
	return (dispatch) => {
		dispatch({
			type: ADD_CUSTOMER_TO_APPEAL,
			id,
			customerId,
			contactPersonId,
		});
	};
}

export function setStatusModalVisibility(payload, id) {
	return (dispatch) => {
		dispatch({
			type: SET_STATUS_MODAL_VISIBILITY,
			payload,
			id,
		});
	};
}

export function setModalStatusLIst(payload, id) {
	return (dispatch) => {
		dispatch({
			type: SET_MODAL_STATUS_LIST,
			payload,
			id,
		});
	};
}

export function removeRefreshAppealModal(id) {
	return (dispatch) => {
		dispatch({
			type: REMOVE_REFRESH_APPEAL_MODAL,
			id,
		});
	};
}

export function setResolutionActions(data, id) {
	return (dispatch) => {
		dispatch({
			type: SET_RESOLUTION_ACTION,
			payload: data,
			id,
		});
	};
}

export function setFirstLevelActions(data, id) {
	return (dispatch) => {
		dispatch({
			type: SET_FIRST_LEVEL_ACTION,
			payload: data,
			id,
		});
	};
}

export function getAppealActions(data, destinations, seDefault) {
	return (dispatch) => {
		const normalizeRouteList = (routeValue) => {
			const routeList = Array.isArray(routeValue) ? routeValue : [routeValue];

			return routeList
				.map((route) => typeof route === 'string' ? route.trim() : null)
				.filter(Boolean);
		};
		const routeFromKey = normalizeRouteList(get(data, 'route.key'));
		const routeFromCode = normalizeRouteList(get(data, 'routeCode'));
		const normalizedRouteCode = routeFromKey.length > 0 ? routeFromKey : routeFromCode;

		const normalizedDestinations = (Array.isArray(destinations) ? destinations : [])
			.map((destination) => Number(destination))
			.filter((destination) => Number.isInteger(destination) && destination > 0);

		const requestData = {
			statusCode: get(data, 'status.id'),
			curOperatorId: get(data, 'curOperatorId'),
			routeCode: normalizedRouteCode,
			destinationIdList: normalizedDestinations,
			appealId: get(data, 'id', null),
		};

		return dispatch(api.mw.appealLabel.appealLabelActionList.initiate(requestData))
			.unwrap()
			.then((response) => {
				const actions = Array.isArray(response?.result) ? response.result : [];

				dispatch({
					type: GET_APPEAL_ACTIONS,
					payload: actions,
					id: data.id,
				});

				if (seDefault && actions.length > 0) {
					const action = actions.find(i => i.action === 'toSave');
					if (!action) {
						return true;
					}

					const setAppeal = setAppealAction({
						appealId: data.id,
						statusCode: action.toState,
						action: action.action,
					}, action.label);

					return setAppeal(dispatch);
				}

				return true;
			})
			.catch();
	};
}

export function setAppealAction(data, label) {
	return (dispatch) => {
		if (data?.action === 'toSave') {
			dispatch({
				type: SET_APPEAL_ACTIONS,
				payload: [],
				label,
				id: data.appealId,
			});

			return Promise.resolve(true);
		}

		return dispatch(api.mw.appeal.appealActionParams.initiate(data))
			.unwrap()
			.then((response) => {
				dispatch({
					type: SET_APPEAL_ACTIONS,
					payload: response.result,
					label,
					id: data.appealId,
				});

				return true;
			});
	};
}

export function showValidationNotification() {
	return (dispatch) => {
		dispatch(showNotification({
			type: NotificationTypes.APPEAL_CHANGE_FAILURE,
			options: { field: 'Заповніть обов\'язкові поля' },
		}));
	};
}

export function clearAppealState(id) {
	return (dispatch) => {
		dispatch({
			type: CLEAR_APPEAL_STATE,
			id,
		});
	};
}

export const hydrateAppealWorkspace = (workspace, options = {}) => (dispatch) => {
	const appeal = workspace?.appeal;

	if (!appeal?.id) {
		return false;
	}

	dispatch({
		type: APPEAL_WORKSPACE_HYDRATE,
		workspace,
		clearUnsavedChanges: options.clearUnsavedChanges === true,
	});

	return appeal;
};

export const hydrateAppealWorkspaceSchema = (appealId, formSchema) => (dispatch) => {
	if (!appealId || !formSchema || typeof formSchema !== 'object') {
		return false;
	}

	dispatch({
		type: APPEAL_WORKSPACE_SCHEMA_HYDRATE,
		id: appealId,
		formSchema,
	});

	return true;
};

export const consumeAppealWorkspaceBootstrap = (appealId) => (dispatch) => {
	if (!appealId) {
		return false;
	}

	dispatch({
		type: APPEAL_WORKSPACE_BOOTSTRAP_CONSUME,
		id: appealId,
	});

	return true;
};

export const getAppeal = (requestData, dirty, updateAppealInCall) => dispatch => {
	if (!dirty) {
		dispatch({
			type: APPEAL_REQUEST,
			id: requestData.id,
		});
	}

	return dispatch(api.mw.appeal.appeal.initiate(requestData))
		.unwrap()
		.then(response => {
			let result = null;

			if (response.success && response.result) {
				result = {
					...response.result,
					timestamp: response.timestamp,
				};

				dispatch({
					type: APPEAL_REQUEST_SUCCESS,
					appealData: result,
				});

				if (updateAppealInCall && result.id.toString() !== result.regnum) {
					dispatch({
						type: UPDATE_CREATED_APPEAL_NAME,
						payload: {
							appeal: {
								id: result.id,
								name: result.regnum,
							},
						},
					});
				}
			} else {
				if (isAppealNotFound(response)) {
					dispatch({
						type: APPEAL_REQUEST_FAILURE,
						appealIsMissing: true,
						id: requestData.id,
					});
				} else if (isAppealAccessDenied(response)) {
					dispatch({
						type: APPEAL_REQUEST_FAILURE,
						appealIsBlocked: true,
						id: requestData.id,
					});

					dispatch({ type: SET_CURRENT_TAB_NAME_BLOCKED });
				} else {
					dispatch({
						type: APPEAL_REQUEST_FAILURE,
						id: requestData.id,
					});
				}
			}

			return result;
		})
		.catch((error) => {
			if (isAppealNotFound(error)) {
				dispatch({
					type: APPEAL_REQUEST_FAILURE,
					appealIsMissing: true,
					id: requestData.id,
				});
			} else if (isAppealAccessDenied(error)) {
				dispatch({
					type: APPEAL_REQUEST_FAILURE,
					appealIsBlocked: true,
					id: requestData.id,
				});

				dispatch({ type: SET_CURRENT_TAB_NAME_BLOCKED });
			} else {
				dispatch({
					type: APPEAL_REQUEST_FAILURE,
					id: requestData.id,
				});
			}

			return null;
		});
};

export const createInteraction = (interactionRequestData = { typeCode: 'PRECRM' }) => {
	return store.dispatch(api.mw.interaction.interactionCreate.initiate(interactionRequestData))
		.unwrap()
		.then((response) => {
			const interactionId = get(response, 'result[0].id');

			if (response.success && interactionId) {
				return interactionId;
			}

			throw new Error('Interaction request error');
		});
};

export const createAppeal = appealRequestData => {
	return store.dispatch(api.mw.interaction.interactionAppealCreate.initiate(appealRequestData))
		.unwrap()
		.then(response => {
			if (response.success && response.result) {
				return response.result;
			}

			throw new Error('Appeal creation request error');
		});
};

export function createNewAppeal({ appealRequestData = {}, interactionRequestData } = {}, intId) {
	return async (dispatch) => {
		let interactionId = intId;

		dispatch({
			type: CREATE_NEW_APPEAL,
		});

		const requestData = {
			appealType: 0,
			appealId: '',
			classCode: 0,
			...appealRequestData,
		};

		try {
			if (shouldCreateAppealWithWorkspaceV2()) {
				const createdAppeal = await createNewAppealWithWorkspaceV2({
					requestData,
					interactionRequestData,
					intId,
					dispatch,
				});

				if (createdAppeal) {
					return createdAppeal;
				}
			}

			if (!interactionId) {
				interactionId = await createInteraction(interactionRequestData);
			}

			const data = {
				...requestData,
				interactionId: interactionId,
			};

			const createdAppeal = await createAppeal(data);

			if (intId) {
				dispatch({
					type: ADD_CREATED_APPEAL,
					payload: {
						appeal: {
							id: createdAppeal.id,
						},
					},
				});
			}

			return createdAppeal;
		} catch (e) {
			dispatch({
				type: CREATE_NEW_APPEAL_ERROR,
				error: 'Something went wrong',
			});

			return null;
		}
	};
}

/**
 * @param requestData - { repeatRequestId, appealId, typeCode }
 * @param onSuccess - callback with created appeal as param
 * @returns Promise of request
 */
export const repeatAppeal = (requestData, onSuccess) => {
	return store.dispatch(api.mw.interaction.interactionCreate.initiate(requestData))
		.unwrap()
		.then(response => {
			const interactionId = get(response, 'result[0].id');

			if (response.success && interactionId) {
				const appealCreatePayload = {
					interactionId,
					appealType: 0,
					classCode: 0,
					typeCode: requestData.typeCode,
					repeatRequestId: requestData.repeatRequestId,
				};

				if (requestData.customerId) {
					appealCreatePayload.customerId = requestData.customerId;
				}

				if (requestData.contactPersonId) {
					appealCreatePayload.contactPersonId = requestData.contactPersonId;
				}

				return store.dispatch(api.mw.interaction.interactionAppealCreate.initiate(appealCreatePayload)).unwrap();
			}

			throw new Error('mw/interaction/create error');
		})
		.then(response => {
			if (response.success && response.result) {
				onSuccess && onSuccess(response.result);
			}
		})
		.catch(console.error);
};

/**
 * @param requestData - { repeatRequestId, appealId }
 * @param onSuccess - callback with created appeal as param
 * @returns Promise of request
 */
export const appointAppeal = (requestData, onSuccess) => {
	return store.dispatch(api.mw.interaction.interactionAppealAppointRepeat.initiate(requestData))
		.unwrap()
		.then(response => {
			if (response.success) {
				onSuccess && onSuccess();
			}
		})
		.catch(console.error);
};

export function getAppealTypesList(id) {
	return (dispatch) => {
		return dispatch(api.mw.appeal.appealFilteredType.initiate({
			classCode: 0,
			node: 'root',
		}))
			.unwrap()
			.then(data => {
				dispatch({
					type: GET_APPEAL_TYPES_LIST_SUCCESS,
					result: data,
					id,
				});

				return true;
			})
			.catch(error => {
				console.log(error, id);

				dispatch({
					type: GET_APPEAL_TYPES_LIST_ERROR,
					error,
					id,
				});

				return false;
			});
	};
}

export function getDynamicFormParams(data, meta = {}) {
	const {
		ctxObjectId, objectType, objectId, objectTypeId, objectTypeCode,
		prevObjectTypeId, openMode, ...restParams
	} = data;
	const requestToken = meta?.requestToken;
	const requestReason = meta?.reason;
	const requestStartedAt = Date.now();

	return (dispatch) => {
		dispatch({
			type: GET_DINAMIC_FORM_PARAMS,
			id: ctxObjectId,
			requestToken,
			requestReason,
		});

		try {
			reportMessage('appeal-form-params-request', {
				scope: 'appeal-form-params',
				appealId: ctxObjectId || null,
				requestToken: requestToken ?? null,
				reason: requestReason || null,
				objectTypeId: objectTypeId ?? null,
				objectTypeCode: objectTypeCode ?? null,
				prevObjectTypeId: prevObjectTypeId ?? null,
				filterKeys: Object.keys(restParams || {}).filter((key) => key.startsWith('filters[')),
				payload: {
					...restParams,
					objectType,
					objectId,
					objectTypeId,
					objectTypeCode,
					prevObjectTypeId,
					openMode,
				},
				at: new Date().toISOString(),
			});
		} catch (error) {}

		return dispatch(api.mw.form.formParams.initiate({
			ctxObjectType: 'INTERACTION_REQUEST',
			ctxObjectId,
			objectType,
			objectTypeId,
			objectId,
			objectTypeCode,
			openMode,
			curStepNum: '1',
			prevObjectTypeId,
			...restParams,
		}))
			.unwrap()
			.then(data => {
				const resultBlocks = Array.isArray(data?.result?.blocks) ? data.result.blocks : [];
				const responseFieldKeys = resultBlocks.flatMap((block) =>
					(Array.isArray(block?.widgets) ? block.widgets : []).map((widget) => widget?.key).filter(Boolean)
				);

				try {
					reportMessage('appeal-form-params-response', {
						scope: 'appeal-form-params',
						appealId: ctxObjectId || null,
						requestToken: requestToken ?? null,
						reason: requestReason || null,
						durationMs: Date.now() - requestStartedAt,
						blockCount: resultBlocks.length,
						widgetCount: responseFieldKeys.length,
						responseFieldKeys,
						at: new Date().toISOString(),
					});
				} catch (error) {}

				dispatch({
					type: GET_DINAMIC_FORM_PARAMS_SUCCESS,
					result: data,
					id: ctxObjectId,
					requestToken,
					requestReason,
				});

				return true;
			})
			.catch(error => {
				try {
					reportMessage('appeal-form-params-error', {
						scope: 'appeal-form-params',
						appealId: ctxObjectId || null,
						requestToken: requestToken ?? null,
						reason: requestReason || null,
						durationMs: Date.now() - requestStartedAt,
						error: error?.message || String(error),
						at: new Date().toISOString(),
					});
				} catch (reportError) {}

				return dispatch({
					type: GET_DINAMIC_FORM_PARAMS_ERROR,
					error,
					id: ctxObjectId,
					requestToken,
					requestReason,
				});
			});
	};
}

export const getAppealStatusList = (appealId, appealType = '') => (dispatch) => {
	dispatch({
		type: GET_APPEAL_STATUS_LIST,
		id: appealId,
	});

	return dispatch(api.mw.appeal.appealStatusList.initiate({
		appealType,
		appealId,
	}))
		.unwrap()
		.then(data => {
			dispatch({
				type: GET_APPEAL_STATUS_LIST_SUCCESS,
				result: data.result,
				id: appealId,
			});

			return true;
		})
		.catch(error => dispatch({
			type: GET_APPEAL_STATUS_LIST_ERROR,
			error,
			id: appealId,
		}));
};

export const saveAppeal = (requestData) => dispatch => {
	const id = requestData.appealId;
	const submitTraceId = get(requestData, 'specialFieldsMeta.submitTraceId', null);

	dispatch({
		type: SAVE_APPEAL,
		id,
	});

	try {
		reportMessage('appeal-save-dispatch', {
			scope: 'appeal-save-action',
			appealId: id || null,
			interactionId: requestData.interactionId || null,
			status: requestData.status || null,
			submitTraceId,
			specialFieldsMeta: requestData.specialFieldsMeta || null,
			bp499: requestData?.dynamicFields?.bp499 ?? null,
			bp501: requestData?.dynamicFields?.bp501 ?? null,
			responseFields: extractAppealSaveResponseDebugFields(requestData?.dynamicFields),
			at: new Date().toISOString(),
		});
	} catch (error) {}

	const params = {
		data: requestData,
		jsonType: true,
	};

	return dispatch(api.mw.interaction.interactionAppealSave.initiate(requestData))
		.unwrap()
		.then(response => {
			try {
				reportMessage('appeal-save-response', {
					scope: 'appeal-save-action',
					appealId: id || null,
					submitTraceId,
					success: Boolean(response?.success),
					errorCode: response?.errorCode ?? null,
					errorMessage: response?.errorMessageText || response?.errorMessage || null,
					at: new Date().toISOString(),
				});
			} catch (error) {}

			if (response.success) {
				dispatch({
					type: SAVE_APPEAL_SUCCESS,
					id,
				});

				const messages = response.result ? response.result.map(appeal => appeal.num).join(', ') : null;

				if (messages) {
					dispatch({
						type: ADD_TABS,
						payload: response.result,
					});
				}

				dispatch(showNotification({
					type: NotificationTypes.SUCCESS,
					options: { message: `Звернення збережено успішно ${messages ? messages : ''}` },
				}));

				return { success: true, skipped: false };
			}

			const skippedReason = get(response, 'result.reason');
			const isSilentSkippedSave = response.success === false
				&& get(response, 'result.skipped') === true
				&& SILENT_SKIPPED_SAVE_REASONS.has(skippedReason);

			if (isSilentSkippedSave) {
				dispatch({
					type: SAVE_APPEAL_SUCCESS,
					id,
				});

				return { success: true, skipped: true, reason: skippedReason };
			}

			const errorMessage = response.errorMessageText
				|| response.errorMessage
				|| 'Збереження звернення пропущено. Спробуйте ще раз.';

			dispatch({
				type: SAVE_APPEAL_ERROR,
				error: response,
				id,
			});

			dispatch(showNotification({
				type: NotificationTypes.APPEAL_CHANGE_FAILURE,
				options: { field: errorMessage },
			}));

			return {
				success: false,
				errorMessage,
				raw: response,
			};
		})
		.catch(error => {
			try {
				reportMessage('appeal-save-error', {
					scope: 'appeal-save-action',
					appealId: id || null,
					submitTraceId,
					errorMessage: error?.message || null,
					errorCode: error?.errorCode || error?.code || null,
					at: new Date().toISOString(),
				});
			} catch (logError) {}

			dispatch({
				type: SAVE_APPEAL_ERROR,
				error,
				id,
			});

			return {
				success: false,
				errorMessage: error?.message || 'Збереження звернення завершилось помилкою.',
				raw: error,
			};
		});
};

export const createAppealWorkspaceV2 = requestData => {
	return store.dispatch(api.mw.appealWorkspace.appealWorkspaceCreate.initiate(requestData)).unwrap();
};

const hasLegacyAppealFlowOverride = () => {
	if (typeof window === 'undefined') {
		return false;
	}

	const locationValue = `${window.location?.search || ''}&${window.location?.hash || ''}`;

	return /(?:[?&])appealFlow=legacy(?:[&#]|$)/i.test(locationValue);
};

const shouldCreateAppealWithWorkspaceV2 = () => {
	if (typeof store.getState !== 'function') {
		return false;
	}

	return get(store.getState(), 'user.appealWorkspaceV2.enabled') === true
		&& !hasLegacyAppealFlowOverride();
};

const createNewAppealWithWorkspaceV2 = async ({ requestData, interactionRequestData, intId, dispatch }) => {
	const response = await createAppealWorkspaceV2({
		...(intId ? { interactionId: intId } : {}),
		...(!intId ? {
			interaction: interactionRequestData || { typeCode: 'PRECRM' },
		} : {}),
		appeal: requestData,
	});

	const createdAppeal = get(response, 'result.appeal');

	if (!response?.success || !createdAppeal?.id) {
		if (Number(response?.errorCode) === 404) {
			return null;
		}

		throw new Error(response?.errorMessage || 'Workspace appeal creation request error');
	}

	const workspace = get(response, 'result.workspace');

	if (workspace?.appeal?.id) {
		hydrateAppealWorkspace(workspace)(dispatch);
	}

	if (intId) {
		dispatch({
			type: ADD_CREATED_APPEAL,
			payload: {
				appeal: { id: createdAppeal.id },
			},
		});
	}

	return createdAppeal;
};

export const getAppealDestinations = (appealId, appealType) => (dispatch) => {
	dispatch({
		type: APPEAL_DESTINATIONS_REQUEST,
		id: appealId,
	});

	const params = {
		data: {
			appealType,
			appealId,
			key: 'ALL',
		},
	};

	return dispatch(api.mw.appeal.appealDestList.initiate({
		appealType,
		appealId,
		key: 'ALL',
	}))
		.unwrap()
		.then(response => {
			if (response.success && response.result) {
				dispatch({
					type: APPEAL_DESTINATIONS_REQUEST_SUCCESS,
					destinations: response.result,
					id: appealId,
				});

				return response.result;
			}

			dispatch({
				type: APPEAL_DESTINATIONS_REQUEST_FAILURE,
				id: appealId,
			});
		})
		.catch(error => {
			console.error(error);

			dispatch({
				type: APPEAL_DESTINATIONS_REQUEST_FAILURE,
				id: appealId,
			});
		});
};

export function lockAppealForm(id) {
	return (dispatch) => {
		dispatch({
			type: LOCK_APPEAL_FORM,
			id,
		});
	};
}

export function unlockAppealForm(id) {
	return (dispatch) => {
		dispatch({
			type: UNLOCK_APPEAL_FORM,
			id,
		});

		dispatch(api.mw.appeal.appealLock.initiate({
			id,
			mode: 'edit',
			duration: 100,
		}))
			.unwrap()
			.then(data => {
				if (data.success) {
					dispatch({
						type: UNLOCK_APPEAL_FORM_SUCCESS,
						version: data.result.version,
						id,
					});
				} else {
					dispatch({
						type: LOCK_APPEAL_FORM,
						id,
					});
				}
			})
			.catch(error => dispatch({
				type: UNLOCK_APPEAL_FORM_ERROR,
				error,
				id,
			}));
	};
}

export function getAppealPriorityList() {
	return (dispatch) => {
		dispatch({
			type: GET_APPEAL_PRIORITY_LIST,
		});

		return dispatch(api.mw.appeal.appealPriorityList.initiate())
			.unwrap()
			.then(data => {
				dispatch({
					type: GET_APPEAL_PRIORITY_LIST_SUCCESS,
					result: data,
				});

				return true;
			})
			.catch(error => {
				dispatch({
					type: GET_APPEAL_PRIORITY_LIST_ERROR,
					error,
				});

				return false;
			});
	};
}

export function getAppealFeedback({ appealId, customerId }) {
	return (dispatch) => {
		dispatch({
			type: GET_APPEAL_FEEDBACK,
			id: appealId,
		});

		return dispatch(api.mw.appeal.appealContactPersons.initiate({
			appealId,
			customerId,
		}))
			.unwrap()
			.then(res => {
				dispatch({
					type: GET_APPEAL_FEEDBACK_SUCCESS,
					result: res.result,
					id: appealId,
				});

				return res.result;
			})
			.catch(error => {
				dispatch({
					type: GET_APPEAL_FEEDBACK_ERROR,
					error,
					id: appealId,
				});

				return false;
			});
	};
}

export function clearAppealFeedback(id) {
	return (dispatch) => {
		dispatch({
			type: CLEAR_APPEAL_FEEDBACK,
			id,
		});
	};
}

export function appealFetching(id) {
	return (dispatch) => {
		dispatch({
			type: APPEAL_FETCHING,
			id,
		});

		return true;
	};
}

export function setSaveAndCreateNew(id, payload) {
	return (dispatch) => {
		dispatch({
			type: SAVE_AND_CREATE_NEW,
			id,
			payload,
		});
	};
}

export function setAppealHasUnsavedChanges(id, payload) {
	return (dispatch) => {
		dispatch({
			type: SET_APPEAL_HAS_UNSAVED_CHANGES,
			id,
			payload,
		});
	};
}

export function clearAllAppeals() {
	return (dispatch) => {
		dispatch({
			type: CLEAR_ALL_APPEALS,
		});
	};
}
